import { cn, tv } from "@utils/tw"

type Props = {
  className?: string
  onClick: () => void
}

export function CloseButton(props: Props) {
  const styles = createStyles()
  return (
    <button onClick={props.onClick} className={styles.base({ className: props.className })}>
      <svg
        className={styles.icon()}
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.707031" width="14" height="1" transform="rotate(45 0.707031 0)" fill="#FEFEFE" />
        <rect x="10.6055" y="0.707031" width="14" height="1" transform="rotate(135 10.6055 0.707031)" fill="#FEFEFE" />
      </svg>
    </button>
  )
}

const createStyles = tv({
  base: [
    "flex-none relative cursor-pointer flex items-center justify-center rounded-sm size-8 outline-none",
    "transition-colors hover:bg-white/15 active:bg-white/20 active:transition-none",
  ],
  slots: {
    icon: "block size-[40%]",
  },
})
